import styles from './StripeProgressBar.module.css'

interface Props {
  percentage: number
  className?: string
  progressColorClass?: string
  handleAboveText?: string
  children?: React.ReactElement
  stripeColor?: 'stripe-gradient' | 'stripe-gradient-purple'
}

const StripeProgressBar = ({
  percentage,
  className = '',
  progressColorClass = 'bg-purple',
  handleAboveText,
  children,
  stripeColor = 'stripe-gradient',
}: Props): React.ReactElement => {
  return (
    <div
      className={`w-full rounded relative shadow-inner-lite h-2 bg-black/10 ${handleAboveText && 'mt-5'} ${className}`}
      data-testid="stripe-progress-bar"
    >
      {/* Progress bar with color */}
      <div
        className={`absolute top-0 bottom-0 left-0 rounded ${progressColorClass}`}
        style={{ width: `${percentage}%` }}
      />

      {/* Progress Stripe Bar */}
      <div
        className={`absolute z-10 top-0 bottom-0 left-0 ${styles[stripeColor]}`}
        style={{ width: `${percentage}%` }}
      />
      {handleAboveText && (
        <p
          className="absolute -top-5 left-0 text-black text-xxs"
          style={{ left: percentage === 0 ? 0 : `calc(${percentage}% - 8px)` }}
        >
          {handleAboveText}
        </p>
      )}
      {children && (
        <div
          className="absolute -top-5 left-0 text-black text-xxs"
          style={{ left: percentage === 0 ? 0 : `calc(${percentage}% - ${(percentage * 40) / 100}px)` }}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default StripeProgressBar
